import React from 'react';
import UserService from 'services/userService';
import './accountMenu.css';

import image_account from 'assets/images/account.png';
import image_logout from 'assets/images/logout.png';
import image_settings from 'assets/images/settings.png';

export default function AccountMenu(props) {
  const onClose = props.onClose;

  if (!props.open)
    return null;

  return (
    <>
      <div className='account-menu'>
        <div className='account-menu-user'><i className='icons8-user' /> {UserService.getUsername()}</div>
        <div className='account-menu-list'>
          <AccountMenuButton title='Manage Account' icon={image_account} href='/Account/Manage' />
          <AccountMenuButton title='Settings' icon={image_settings} href='/Account/Settings' />
          <AccountMenuButton title='Logout' icon={image_logout} id='logout' href='/Logout' />
        </div>
      </div>
      <div className='fade modal-backdrop show' style={{ marginTop: 60 }} onClick={onClose}></div>
    </>
  );
}

function AccountMenuButton(props) {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  const renderContent = (content) => {
    if (props.href) {
      return (
        <a href={props.href}>
          {content}
        </a>
      );
    }
    return content;
  };

  return renderContent(
    <div id={props.id} className='account-menu-button d-flex align-items-center' onClick={handleClick}>
      <div className='account-menu-button-icon mr-2'>
        <img src={props.icon} alt='i' style={{ height: 38 }} />
      </div>
      <div className='flex-grow-1'>
        {props.title}
      </div>
    </div>
  );
}